import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import FormField from "gradifui/mixins/FormField";
import isUndefined from "lodash/isUndefined";
import map from "lodash/map";
import { PropTypes as MobxPropTypes } from "mobx-react";
import isFunction from "lodash/isFunction";
import clientErrorLogger from "util/clientErrorLogger";
import autobind from "autobind-decorator";

class CustomSelect extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(React.Component)]),
        placeholder: PropTypes.string,
        placeholderValue: PropTypes.string,
        fieldName: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        disablePlaceholder: PropTypes.bool,
        options: MobxPropTypes.arrayOrObservableArrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                // eslint-disable-next-line react/forbid-prop-types
                value: PropTypes.any.isRequired
            })
        ).isRequired
    };

    @autobind
    handleSelectChange(e) {
        // save data more aggressively, since select should only have discrete changes
        if (!this.inputElement) {
            clientErrorLogger.notify("No input element defined for form field", "error");
            return;
        }

        this.value = this.inputElement.value;
        this.updateBackingValue(true);
        if (isFunction(this.props.onChange)) {
            this.props.onChange(e);
        }
    }

    render() {
        const {
            fieldName,
            label,
            disabled,
            disablePlaceholder,
            name,
            id
        } = this.props;

        let placeholderValue = isUndefined(this.props.placeholderValue) ? "" : this.props.placeholderValue;
        let placeholderOption = (!isUndefined(this.props.placeholder) && !isNull(this.props.placeholder))
            ? map([this.props.placeholder], placeholder => <option key={placeholder} value={placeholderValue} disabled={disablePlaceholder} default={true}>{placeholder}</option>)
            : undefined;

        return (
            <div className={this.getClassNames("custom-select")}>
                {!isEmpty(label) &&
                    <label htmlFor={fieldName}>{label}</label>
                }
                <select
                    id={id || fieldName}
                    name={name || fieldName}
                    ref={this.setInputRef}
                    value={this.readValue()}
                    onChange={this.handleSelectChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    aria-label={label || this.props.placeholder}
                    disabled={disabled}
                >
                    {placeholderOption}
                    {map(this.props.options, option => {
                        return (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        );
                    })}
                </select>
                {this.renderErrors()}
            </div>
        );
    }
}

export default FormField(CustomSelect);
